import ContentfulUserReviewGroup from '../reference-blocks/contentful-user-review-group'
import ContentfulTextWithImageSection from '../reference-blocks/contentful-text-with-image-section'

import generateRTFComponent from '.'

const CRMContentRTF = generateRTFComponent({
  ContentfulUserReviewGroup,
  ContentfulTextWithImageSection,
})

export default CRMContentRTF
